import React, { useState } from 'react';
import styled from 'styled-components';
import Cookies from 'js-cookie';
import Typography from "@mui/material/Typography";
import NotificationAlert from "react-notification-alert";

const LoginPage = styled.div`
  background-image: url(${require('../../assets/img/BG.jpg')});
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed; /* Fixed background */
  background-position: center; /* Center the background image */
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CardContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(128, 128, 128, 0.25);
  text-align: center;
  width: 400px;
  transition: background-color 0.3s ease; /* Smooth background color transition */
`;

const InputField = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  &:focus {
    outline: none;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 10px;
`;

function Login() {
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const notificationAlertRef = React.useRef(null);

  const showNotification = (message, type) => {
    const options = {
      place: "tc",
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 3,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    // Show "Logging in" notification
    showNotification("در انتظار پاسخ از سامانه، لطفا منتظر بمانید", "info");

    const formData = new URLSearchParams();
    formData.append('username', loginData.username);
    formData.append('password', loginData.password);

    try {
      const response = await fetch('https://back.actelmon.ir/api/doctor/login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        const responseData = await response.json();
        const token = responseData.access;

        if (token) {
          showNotification("ورود موفق", "success");
          Cookies.set('token', token);
          localStorage.setItem('token', token);
          window.location.href = '/rtl/dashboard';
        } else {
          showNotification('ورود ناموفق! لطفا نام کاربری و رمز عبور را دوباره وارد کنید','danger');
        }
      } else {
        showNotification('ورود ناموفق! لطفا نام کاربری و رمز عبور را دوباره وارد کنید','danger');
      }
    } catch (error) {
      console.error('Login error:', error);
      showNotification('در هنگام ورود به سیستم اختلالی به وجود آمده، لطفا لحظاتی بعد دوباره تلاش کنید','danger');
    }
  };

  return (
    <LoginPage>
      <CardContainer style={{paddingBottom:'8px'}}>
        <div style={{ display: 'flex', alignItems: 'center',justifyContent:'center', padding: '20px' }}>
          <img
            src={require('../../assets/img/blueblack.png')}
            alt="Logo"
            style={{ width: 'auto', height: '90px' }}
          />
        </div>
        <form onSubmit={handleLoginSubmit}
              style={{padding:'10px'}}>
          <InputField
            type="text"
            placeholder="نام کاربری"
            value={loginData.username}
            onChange={(e) =>
              setLoginData({ ...loginData, username: e.target.value })
            }
            style={{ direction: 'rtl', textAlign: 'right' }}
          />
          <InputField
            type="password"
            placeholder="رمز عبور"
            value={loginData.password}
            onChange={(e) =>
              setLoginData({ ...loginData, password: e.target.value })
            }
            style={{ direction: 'rtl', textAlign: 'right' }}
          />
          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
          <SubmitButton
            style={{
              backgroundColor: '#138C97',
            }}
            type="submit"
          >
            ورود به سامانه
          </SubmitButton>
        </form>
        <NotificationAlert ref={notificationAlertRef} />
        <Typography variant="h7" style={{ color: '#000', marginTop: '10px',  }}>
          رمز عبور خود را فراموش کرده اید؟ <a href="http://actelmon.ir/call-support/" style={{ color: '#00008B' }}>اینجا کلیک کنید</a>
        </Typography>
      </CardContainer>

    </LoginPage>
  );
}

export default Login;